export function formatDateISO(value) {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return date.toISOString();
}
const DEFAULT_DATE_OPTIONS = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
};
export function formatDate(value, options = DEFAULT_DATE_OPTIONS) {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return new Intl.DateTimeFormat(undefined, options).format(date);
}
const DEFAULT_RELATIVE_TIME_OPTIONS = {
    numeric: 'auto',
};
const DIVISIONS = [
    { amount: 60, name: 'seconds' },
    { amount: 60, name: 'minutes' },
    { amount: 24, name: 'hours' },
    { amount: 7, name: 'days' },
    { amount: 4.34524, name: 'weeks' },
    { amount: 12, name: 'months' },
    { amount: Number.POSITIVE_INFINITY, name: 'years' },
];
export function formatRelativeTime(inputValue, inputSince = new Date(), options = DEFAULT_RELATIVE_TIME_OPTIONS) {
    let value = inputValue;
    let since = inputSince;
    if (typeof value === 'string') {
        value = new Date(value);
    }
    if (typeof since === 'string') {
        since = new Date(since);
    }
    let duration = (value.getTime() - since.getTime()) / 1000;
    const formatter = new Intl.RelativeTimeFormat(undefined, options);
    for (let i = 0; i <= DIVISIONS.length; i++) {
        const division = DIVISIONS[i];
        if (Math.abs(duration) < division.amount) {
            return formatter.format(Math.round(duration), division.name);
        }
        duration /= division.amount;
    }
    return '';
}
